import { FC } from 'react';
import { WarningLabel } from '~/components/warning-label';
import { useAtomValue } from 'jotai';
import { $CurrentArticleAsAvailable } from '@article/shared/atoms/current-article';

export const WarningLabelSection: FC = () => {
  const { illegalInfo } = useAtomValue($CurrentArticleAsAvailable);

  return <WarningLabel illegalInfo={illegalInfo} />;
};
